import Vue from 'vue';
import Router from 'vue-router';

import DeckPage from '../deck/DeckPage.vue';
import RevealedCard from '../deck/RevealedCard.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/reveal/:cardValue',
      name: 'RevealedCard',
      component: RevealedCard,
      props: true,
    },
    {
      path: '/:deck',
      name: 'Deck',
      component: DeckPage,
      props: true,
    },
    {
      path: '/',
      redirect: '/standard'
    }
  ],

});
